// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bho_wx bho_jb bho_xl bho_i bho_j bho_q bho_vt bho_et bho_so bho_sp bho_eg","CommentsButton__icon":"il_b bho_rz"};